.gridster {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  flex: 1 1 auto;
  overflow: auto;
  user-select: none;
}

.gridster-item {
  box-sizing: border-box;
  position: absolute;
  z-index: 1;
  display: none;
  transition: 0.3s;
  user-select: text;
}

.gridster-item.gridster-item-moving {
  cursor: grabbing;
  opacity: 0.5;
  z-index: 3;
}

.gridster-item.gridster-item-resizing {
  z-index: 3;
}

.gridster-item.gridster-item-resizing,
.gridster-item.gridster-item-moving {
  transition: 0s;
  box-shadow:
    0 0 5px 5px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 1px 18px 0 rgba(0, 0, 0, 0.12);
}

.gridster-preview {
  position: absolute;
  display: none;
  z-index: 2;
  pointer-events: none;
  border: 2px dashed rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.06);
}

.gridster-item-resizable-handler {
  position: absolute;
  z-index: 2;
  touch-action: none;
}

.gridster-item-resizable-handler.handle-n {
  cursor: ns-resize;
  height: 10px;
  right: 0;
  top: 0;
  left: 0;
}

.gridster-item-resizable-handler.handle-e {
  cursor: ew-resize;
  width: 10px;
  bottom: 0;
  right: 0;
  top: 0;
}

.gridster-item-resizable-handler.handle-s {
  cursor: ns-resize;
  height: 10px;
  right: 0;
  bottom: 0;
  left: 0;
}

.gridster-item-resizable-handler.handle-w {
  cursor: ew-resize;
  width: 10px;
  left: 0;
  top: 0;
  bottom: 0;
}

.gridster-item-resizable-handler.handle-ne {
  cursor: ne-resize;
  width: 10px;
  height: 10px;
  right: 0;
  top: 0;
}

.gridster-item-resizable-handler.handle-nw {
  cursor: nw-resize;
  width: 10px;
  height: 10px;
  left: 0;
  top: 0;
}

.gridster-item-resizable-handler.handle-se {
  cursor: se-resize;
  width: 0;
  height: 0;
  right: 0;
  bottom: 0;
  border-style: solid;
  border-width: 0 0 10px 10px;
  border-color: transparent;
}

.gridster-item-resizable-handler.handle-sw {
  cursor: sw-resize;
  width: 10px;
  height: 10px;
  left: 0;
  bottom: 0;
}

.gridster-item:hover .gridster-item-resizable-handler.handle-se {
  border-color: transparent transparent #ccc;
}

.drag-handle {
  cursor: grab;
}

.gridster-item-moving .drag-handle {
  cursor: grabbing;
}
